export enum EdsDefinitionSections {
  SidePanel = 'SidePanel',
  MyTasks = 'MyTasks',
  AllClaimSets = 'AllClaimSets',
  AllClaims = 'AllClaims',
  ProfileDetails = 'ProfileDetails',
  UsersMaintenance = 'UsersMaintenance',
  Milestones = 'Milestones',
  RHPanelNotes = 'RHPanelNotes',
  SystemPage = 'SystemPage',
}
